function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { formatDate } from '@applyboard/ab-common';
import { IconButton } from '@applyboard/ui-components';
import CompactTestScores from "../../../../../components/CompactTestScores";
import IeltsReviewModal from "../../../../../components/Modals/IeltsReview";
import { BottomText } from "../../../../../components/style/CommonStyles";
import { SidebarList, SidebarNotAvailableStyled } from "../../styles";
import useDispatch from "../../../../../hooks/useDispatch";
import { ieltsModalShowAction } from "../../../../../store/actions/ielts_modal";
var TestScore = function TestScore(_ref) {
  var displayModalButton = _ref.displayModalButton,
    student_information_id = _ref.student_information_id,
    testScores = _ref.testScores,
    refetchTestScores = _ref.refetchTestScores;
  var dispatch = useDispatch();
  if (!testScores.type) {
    return /*#__PURE__*/React.createElement(SidebarNotAvailableStyled, null, "No Test Scores");
  }
  var testScoresFormatted = formatTestScores(testScores);
  var expiredExam = checkIsExamExpired(testScores);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SidebarList, null, /*#__PURE__*/React.createElement("span", null, testScoresFormatted.type), /*#__PURE__*/React.createElement(CompactTestScores, {
    testScores: testScoresFormatted,
    type: "english"
  }), displayModalButton && testScoresFormatted.type.toLowerCase() === 'ielts' && /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return dispatch(ieltsModalShowAction());
    },
    "data-tip": "Review using TRF",
    "aria-label": "Review using TRF",
    size: "small"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "search"
  }))), testScoresFormatted.exam_date && /*#__PURE__*/React.createElement(BottomText, null, "Exam Date: ", testScoresFormatted.exam_date), displayModalButton && /*#__PURE__*/React.createElement(IeltsReviewModal, {
    refetchTestScores: refetchTestScores,
    student_information_id: student_information_id,
    expiredExam: expiredExam
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var formatTestScores = function formatTestScores(testScores) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var returnedScores = testScores;
  if (testScores.type && testScores.exam_date) {
    returnedScores = _objectSpread(_objectSpread({}, testScores), {}, {
      exam_date: formatDate(testScores.exam_date)
    });
  }
  if (returnedScores.type === 'PROVIDE_LATER') {
    returnedScores.type = 'Will be provided later';
  }
  return returnedScores;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var checkIsExamExpired = function checkIsExamExpired(testScores) {
  var _testScores$verified_, _testScores$verified_2;
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var twoYearsAgo = new Date();
  twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
  var examDate = testScores === null || testScores === void 0 ? void 0 : (_testScores$verified_ = testScores.verified_ielts_score) === null || _testScores$verified_ === void 0 ? void 0 : (_testScores$verified_2 = _testScores$verified_.test_results) === null || _testScores$verified_2 === void 0 ? void 0 : _testScores$verified_2.date_of_examination;
  return !!(examDate && new Date(examDate) < twoYearsAgo);
};
export default TestScore;